import React from "react";
import StringFilter from "./filters/StringFilter";
import BoolFilter from "./filters/BoolFilter";
import DateRangeFilter from "./filters/DateRangeFilter";
import NumberFilter from "./filters/NumberFilter";

const filters = {
    "string": StringFilter,
    "bool": BoolFilter,
    "dateRange": DateRangeFilter,
    "number": NumberFilter,
}

function FilterRow(props) {

    function getValue(name) {
        const isDatetime = props.filters.find(filter => filter.label === name+'_before') && props.filters.find(filter => filter.label === name+'_after')
        if (isDatetime) {
            return {
                after: props.filters.filter(filter => filter.label === name+'_after')[0].value,
                before: props.filters.filter(filter => filter.label === name+'_before')[0].value
            }
        } else {
            const filter = props.filters.find(filter => filter.label === name)
            if (filter) {
                return filter.value
            } else {
                return ''
            }
        }
    }

    function getFilter(header) {
        const Filter = filters[header.filter]
        // return <Filter label={filter.label} name={filter.name} onChange={filter.onChange} value={filter.value}/>
        return <Filter name={header.label} onChange={props.filterUpdate} value={getValue(header.label)}/>
    }

    return (
        <tr className="filter_row">
            {props.headers.map((header, index) => (
                <td className="fieldWrapper" key={index}>
                    {header.filter ? getFilter(header) : null}
                </td>
            ))}
            {
                props.actions ?
                    <th className="col_headers"></th>
                    : null
            }
        </tr>
    )
}

export default FilterRow
